/**
 * Unwraps a Strapi node to its plain attribute object.
 *
 * Handles both CMS generations, because the v4 -> v5 migration is incremental
 * and shared components (banners, cards) receive data from either:
 *   - v4 single:   { data: { attributes } }
 *   - v4 multiple: { data: [{ attributes }] }
 *   - v5 single:   { url, … }            (entries/media come back flat)
 *   - v5 multiple: [{ url, … }]          (lists are plain arrays)
 */
export default function strapiSingleAttribute(node) {
  if (!node) return null;
  try {
    if (node.data !== undefined) {
      const entry = Array.isArray(node.data) ? node.data[0] : node.data;
      return entry?.attributes ?? null;
    }
    if (Array.isArray(node)) return node[0] ?? null;
    return node;
  } catch (e) {
    return null;
  }
}

export function stripHtmlTags(html: string): string {
  return html.replace(/<[^>]*>?/gm, '');
}
